import { useMutate, UseMutateProps } from 'restful-react'
import {
  IUserAuthResponse,
  IMagicTokenLogin,
  IPasswordLogin,
  IResetPasswordLogin,
  IConfirmationTokenLogin,
} from 'types'
import { getApiUrl } from 'utils/api/apiHelpers'
import { ENDPOINTS } from 'utils/api/callApi'
import { getRestfulProps } from 'utils/getRestfulProps'

interface IData extends IUserAuthResponse {}

interface IError {}

interface IQueryParams {}

interface IRequestBody {
  userLogin: IMagicTokenLogin | IPasswordLogin | IResetPasswordLogin | IConfirmationTokenLogin
}

interface IPathParams {}

interface IUseSignInProps
  extends Omit<
    UseMutateProps<IData, IError, IQueryParams, IRequestBody, IPathParams>,
    'path' | 'base' | 'verb'
  > {}

export const useSignIn = (props: IUseSignInProps) => {
  return useMutate<IData, IError, IQueryParams, IRequestBody, IPathParams>({
    base: getApiUrl('MARKETPLACE'),
    path: `${ENDPOINTS.signIn}`,
    verb: 'POST',
    ...getRestfulProps(),
    ...props,
  })
}
